import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import dynamic from "next/dynamic";

import Button from "~/common/ui/Button";
import useCollectMetrics from "~/common/hooks/useCollectMetrics";
import Avatar from "./Avatar";

const Metrics = dynamic(() => import("./Metrics"), {
  ssr: false,
});

export default function ContactCard({ owner, car, trackEntity }) {
  const { id: carId, type, status } = car;
  const { isBusiness, address, slug, avatar, schedule, name, contactNumber } =
    owner;

  const { collectCallButtonClickAction } = useCollectMetrics({
    entity: trackEntity,
  });

  return (
    <div className="rounded-lg pb-1 border-2 flex flex-col p-4 gap-4">
      <div className="flex gap-4">
        <div className="w-4/12">
          <Avatar
            businessSlug={slug}
            isBusiness={isBusiness}
            ownerAvatar={avatar}
          />
        </div>
        <div className="flex flex-col justify-between w-8/12">
          <div className="flex flex-col">
            <h3 className="text-brand-dark text-lg font-bold">{name}</h3>

            {isBusiness && address && (
              <div>
                <span className="text-xs font-semibold text-gray-500">
                  Dirección:
                </span>
                <p className="text-gray-600 font-semibold text-sm">{address}</p>
              </div>
            )}

            {isBusiness ? (
              schedule && (
                <div>
                  <span className="text-xs font-semibold text-gray-500">
                    Horario:
                  </span>
                  <p className="text-gray-600 font-semibold text-sm">
                    {schedule}
                  </p>
                </div>
              )
            ) : (
              <>
                <p className="text-gray-500 font-semibold text-sm">
                  Contacta directo al vendedor
                </p>
              </>
            )}
            <Metrics carId={carId} car={car}/>
          </div>

          {/* <ManagmentCar
            carId={carId}
            carStatus={status}
            business={owner.business}
            carPlan={type}
          /> */}
        </div>
      </div>

      <hr />

      <div className="flex items-center pb-1 justify-between">
        <span className="text-xl text-gray-800">{contactNumber}</span>
        <Button className="bg-brand-primary self-center flex justify-center items-center gap-2">
          <a
            className="flex gap-2 items-center"
            onClick={() => {
              collectCallButtonClickAction(carId);
            }}
            href={`tel:${contactNumber}`}
          >
            <FaPhoneAlt fontSize={18} />
            Llamar al vendedor
          </a>
        </Button>
      </div>
    </div>
  );
}
